export function convertToPlus3Timezone(isoDateString: string): string {
    const date = new Date(isoDateString);

    const moscowTime = new Date(date.getTime() + 3 * 60 * 60 * 1000);

    const daysOfWeek = [
        'Воскресенье',
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота',
    ];
    const dayOfWeek = daysOfWeek[moscowTime.getUTCDay()];

    const dayOfMonth = moscowTime.getUTCDate();

    const months = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря',
    ];
    const month = months[moscowTime.getUTCMonth()];

    const year = moscowTime.getUTCFullYear();

    const hours = moscowTime.getUTCHours().toString().padStart(2, '0');
    const minutes = moscowTime.getUTCMinutes().toString().padStart(2, '0');

    return `${dayOfWeek}, ${dayOfMonth} ${month} ${year} в ${hours}:${minutes}`;
}
